import { FilterX, Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Select } from '@/components/ui/select'
import { EMPTY_CUSTOMER_FILTER, RECENCY, type CustomerFilter } from '../customerFilter'
import { STAGES } from '../types'
import { useCategories } from '../categoriesApi'
import { useCrm } from '../ui'

/** Müşteri listesi filtre satırı (arama, aşama, sorumlu, bölge, son görüşme). */
export function CustomerFilters({ value, onChange, regions }: { value: CustomerFilter; onChange: (f: CustomerFilter) => void; regions: string[] }) {
  const { t } = useTranslation()
  const categories = useCategories()
  const { staff } = useCrm()
  const set = <K extends keyof CustomerFilter>(k: K, v: CustomerFilter[K]) => onChange({ ...value, [k]: v })
  const filtered = JSON.stringify(value) !== JSON.stringify(EMPTY_CUSTOMER_FILTER)
  const sel = <K extends 'stage' | 'owner' | 'region' | 'recency' | 'category'>(k: K, label: string, options: { value: CustomerFilter[K]; label: string }[]) => (
    <div className="min-w-0 space-y-1">
      <label htmlFor={`cf-${k}`} className="text-xs text-muted-foreground">
        {label}
      </label>
      <Select id={`cf-${k}`} size="sm" value={value[k]} onChange={(v) => set(k, v as CustomerFilter[K])} options={options} />
    </div>
  )
  return (
    <div className="grid grid-cols-2 gap-2 border-b p-3 sm:grid-cols-3 lg:grid-cols-[minmax(0,1.4fr)_repeat(5,minmax(0,1fr))_auto] lg:items-end">
      <div className="relative col-span-2 sm:col-span-3 lg:col-span-1">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" aria-hidden />
        <Input value={value.q} onChange={(e) => set('q', e.target.value)} placeholder={t('crm.list.search')} aria-label={t('crm.list.search')} className="h-8 pl-8" />
      </div>
      {sel('stage', t('crm.cols.stage'), [{ value: 'all', label: t('common.all') }, ...STAGES.map((s) => ({ value: s, label: t(`crm.stage.${s}`) }))])}
      {sel('owner', t('crm.cols.owner'), [{ value: 'all', label: t('common.all') }, ...staff.map((s) => ({ value: s.id, label: s.name }))])}
      {sel('region', t('crm.fields.region'), [{ value: 'all', label: t('common.all') }, ...regions.map((r) => ({ value: r, label: r }))])}
      {sel('recency', t('crm.cols.lastMeeting'), RECENCY.map((r) => ({ value: r, label: t(`crm.recency.${r}`) })))}
      {sel('category', t('crm.category.label'), [{ value: 'all', label: t('common.all') }, { value: 'none', label: t('crm.category.none') }, ...(categories.data ?? []).map((c) => ({ value: c.id, label: c.name }))])}
      <Button variant="ghost" size="sm" onClick={() => onChange(EMPTY_CUSTOMER_FILTER)} disabled={!filtered} className="col-span-2 sm:col-span-1">
        <FilterX />
        {t('common.clear')}
      </Button>
    </div>
  )
}
